<template>
  <div>
    <b-row>
      <b-col md="9">
        <v-select
          v-model="selectedTags"
          placeholder="Type here to search tags"
          :options="filteredTags"
          :get-option-label="(option) => option.name.en"
          multiple
          :close-on-select="false"
          :clearable="false"
          @search="fetchTags"
        />
      </b-col>
      <b-col md="3">
        <b-button
          :disabled="submitting || !selectedTags.length"
          variant="primary"
          block
          @click="submitTags"
        >
          <b-spinner
            v-if="submitting"
            small
          />
          <span v-else>Submit Tags</span>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { ref } from '@vue/composition-api'
import { debounce } from 'lodash'
import {
  BButton, BRow, BCol, BSpinner,
} from 'bootstrap-vue'

export default {
  components: {
    vSelect,
    BButton,
    BRow,
    BCol,
    BSpinner,
  },
  props: {
    businessId: {
      type: String,
      required: true,
    },
  },
  setup(props, ctx) {
    const selectedTags = ref([])
    const filteredTags = ref([])
    const fetchTags = debounce(async (search, loading) => {
      if (!search) return
      loading(true)
      const res = await ctx.root.$store.dispatch('business/getTags', {
        params: {
          name: search,
          autoComplete: true,
        },
      })
      filteredTags.value = res.data.data.tags
      loading(false)
    }, 1000)

    const submitting = ref(false)
    const submitTags = async () => {
      try {
        submitting.value = true
        await ctx.root.$store.dispatch('business/createNewBusinessTags', {
          businessId: props.businessId,
          tags: selectedTags.value,
        })
        filteredTags.value = []
        selectedTags.value = []
        ctx.emit('tags-added')
      } finally {
        submitting.value = false
      }
    }
    return {
      selectedTags,
      filteredTags,
      fetchTags,
      submitting,
      submitTags,
    }
  },
}
</script>
